import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import useAnalyticsComponentViewed from 'hooks/useAnalyticsComponentViewed'
import {
  TABLE_OF_CONTENT_SECTION,
  TABLE_OF_CONTENT_TITLE,
} from 'utils/testing/testIDs'

import { ACTIONS, OPTIONS, baseAnalyticsOptions } from '../analytics/constants'
import { GrowLeafTip } from './GrowLeafTip'
import { Container, PaddingWrapper, Title } from './styled-components'
import { Carousel as TableOfContentCarousel } from './TableOfContentCarousel/Carousel'

const TableOfContent = ({
  beneficiaryId,
  custodianNickname,
}: {
  beneficiaryId: string
  custodianNickname: string
}): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()
  const inViewContainerRef = useAnalyticsComponentViewed({
    threshold: 0.4,
    action: ACTIONS.SCREEN_VIEW,
    payload: {
      ...baseAnalyticsOptions,
      action: 'Viewed',
      beneficiaryId,
      context: OPTIONS.TABLE_OF_CONTENT.context,
      event_description: 'Early Quarterly Recaps Screen Viewed',
      index_position: OPTIONS.TABLE_OF_CONTENT.position,
      object: 'Screen',
      object_name: 'earlyQuarterlyRecaps',
    },
  })

  return (
    <Container data-testid={TABLE_OF_CONTENT_SECTION} ref={inViewContainerRef}>
      <PaddingWrapper>
        <Title data-testid={TABLE_OF_CONTENT_TITLE}>
          {getRemoteString({
            key: 'early.recap.table_of_contents.title',
          })}
        </Title>
      </PaddingWrapper>
      <TableOfContentCarousel custodianNickname={custodianNickname} />
      <PaddingWrapper>
        <GrowLeafTip />
      </PaddingWrapper>
    </Container>
  )
}

export { TableOfContent }
